import PropTypes from 'prop-types';

import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';

import ImmutablePropTypes from 'react-immutable-proptypes';
import ImmutablePureComponent from 'react-immutable-pure-component';
import { connect } from 'react-redux';

import { IconButton } from 'mastodon/components/icon_button';
import { ImageIcon } from 'mastodon/components/icons/image';

const messages = defineMessages({
  upload: { id: 'upload_button.label', defaultMessage: 'Add images, a video or an audio file' },
});

const makeMapStateToProps = () => {
  const mapStateToProps = state => ({
    acceptContentTypes: state.getIn(['media_attachments', 'accept_content_types']),
  });

  return mapStateToProps;
};

const iconStyle = {
  height: null,
  lineHeight: '27px',
};

class UploadButton extends ImmutablePureComponent {

  static propTypes = {
    disabled: PropTypes.bool,
    onSelectFile: PropTypes.func.isRequired,
    style: PropTypes.object,
    resetFileKey: PropTypes.number,
    acceptContentTypes: ImmutablePropTypes.listOf(PropTypes.string).isRequired,
    intl: PropTypes.object.isRequired,
    isComposeForm: PropTypes.bool,
    usageType: PropTypes.oneOf(['create', 'comment']),
  };

  handleChange = (e) => {
    if (e.target.files.length > 0) {
      this.props.onSelectFile(e.target.files);
    }
  };

  handleClick = () => {
    this.fileElement.click();
  };

  setRef = (c) => {
    this.fileElement = c;
  };

  render () {
    const { intl, resetFileKey, disabled, acceptContentTypes, usageType } = this.props;

    const message = intl.formatMessage(messages.upload);
    const isComment = usageType === 'comment';

    return (
      <div className={`compose-form__upload-button ${this.props.isComposeForm && 'compose-form___action-full'}`} onClick={this.props.isComposeForm && this.handleClick}>
        <IconButton 
          icon='paperclip' 
          iconComponent={ImageIcon} 
          title={message} 
          disabled={disabled} 
          onClick={isComment ? this.handleClick : undefined}
          className='compose-form__upload-button-icon' 
          size={18} 
          inverted 
          style={iconStyle} 
        />
        <label>
          <span style={{ display: 'none' }}>{message}</span>
          <input
            key={resetFileKey}
            ref={this.setRef}
            type='file'
            name='file-upload-input'
            multiple
            accept={acceptContentTypes.toArray().join(',')}
            onChange={this.handleChange}
            disabled={disabled}
            style={{ display: 'none' }}
          />
        </label>
        {this.props.isComposeForm && (
          <FormattedMessage
            id='compose.upload_image'
            defaultMessage='Image'
          />
        )}
      </div>
    );
  }

}

export default connect(makeMapStateToProps)(injectIntl(UploadButton));
